import { createCookie, readCookie } from 'cookie.manager';

const bannerCookieName: string = 'showCookiesBanner';
export const analyticCookieName: string = 'showAnalyticsCookies';

export function settingsCookies() {
  let analyticCookie = readCookie(analyticCookieName);
  let analyticCookieValue = analyticCookie
    ? Boolean(JSON.parse(analyticCookie))
    : null;

  return {
    [analyticCookieName]: analyticCookieValue,
  };
}

export function setCookie(name = bannerCookieName, value = true) {
  const cookieDuration = 365; // 1 year (value in days)
  const domain = process.env.REACT_APP_COOKIE_DOMAIN as string;
  createCookie(name, value, cookieDuration, domain);
}
